<template>
  <div class="advanced-select__container">
    <multiselect
      :label="label"
      :track-by="label"
      :name="name"
      :disabled="disabled"
      :placeholder="placeholder"
      :options="options"
      :searchable="false"
      :show-labels="false"
      :close-on-select="closeOnSelect"
      :multiple="multiple"
      v-model="selectedValue"
      :open-direction="direction"
      :max-height="maxHeight"
      :custom-label="nameWithLang"
      :hide-selected="hide"
      @open="onOpen"
      @close="onClose"
      :tabindex="tabindex"
      @input="onChange"
      @keydown.enter.native.stop="enter">
      <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length">{{getStatusValues}}</span></template>
      <template slot="noOptions">{{$t('listIsEmpty')}}</template>
    </multiselect>
    <md-input type="hidden"></md-input>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import utils from '@/utils/utils.js'

export default {
  name: 'advanced-select',
  props: {
    options: [Object, Array],
    placeholder: String,
    label: {
      type: String,
      default: 'label'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'botton'
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 250
    },
    i18key: {
      type: Boolean,
      default: false
    },
    name: String,
    value: null,
    hide: false
  },
  components: {
    'multiselect': Multiselect
  },
  computed: {
    parentContainer () {
      return utils.getClosestVueParent(this.$parent, 'md-field')
    },
    getStatusValues () {
      return this.selectedValue.map(x => {
        if(this.i18key){
          return this.$t(x.label)
        } else {
          return x.label
        }
      }).join(', ')
    },
    selectedValue: {
      get () {
        if (!this.multiple) {
          for (let i in this.options) {
            if (this.options[i].value === this.value) {
              return this.options[i]
            }
          }
        } else {
          let optionsFinal = []
          for (let i in this.options) {
            for (let j in this.options) {
              if (this.options[i].value === this.value[j]) {
                optionsFinal.push(this.options[i])
              }
            }
          }
          return optionsFinal
        }
        return null
      },
      set (val) {
        if (!this.multiple) {
          if(val){
            this.$emit('input', val.value)
          } else {
            this.$emit('input', val)
          }
        } else {
          this.$emit('input', val.map(x => x.value))
        }
      }
    },
    tabindex: function () {
      return this.disabled ? -1 : 0
    }
  },
  methods: {
    onSelect () {
      this.parentContainer.$el.classList.add('md-has-value')
    },
    onOpen () {
      this.parentContainer.$el.classList.add('md-input-focused')
    },
    onClose () {
      this.parentContainer.$el.classList.remove('md-input-focused')
    },
    onChange () {
      this.$emit('onChange')
    },
    enter () {
      this.$emit('enter')
    },
    nameWithLang ({ value, label }) {
      if(this.i18key){
        return this.$t(label)
      } else {
        return label
      }
    }
  }
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  .md-input-container {
    &.md-input-placeholder {
      &.md-advanced-select {
        label {
          opacity: 1;
          top: 22px;
          font-size: 16px;
          color: #222222;
        }

        &.md-input-focused {
          label {
            opacity: 1;
            font-size: 16px;
            color: #222222 !important;
          }
        }

        &.md-has-value {
          label {
            top: 0;
            font-size: 12px;
            color: #858585 !important;
          }
        }

        &.md-input-invalid {
          label {
            color: #222222 !important;
          }

          &.md-has-value {
            label {
              color: #858585 !important;
            }
          }
        }
      }
    }
  }

  /* COMPONENT: commom/AdvancedSelect.vue */
  .advanced-select__container {
    position: relative;
    width: 100%;
    cursor: pointer;

    .multiselect {
      color: inherit;
      min-height: 30px;

      &--active{
        z-index: 9;
      }

      &--active .multiselect__select {
        transform: scaleY(-1);
      }

      &__select {
        text-align: right;
        padding: 0;
        height: 30px;
        width: 100%;
        top: 0;
        right: 0;
        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
          z-index: 2;
        }

        &:before {
          position: absolute;
          color: #c2c2c2;
          border-color: #c2c2c2 transparent transparent;
          top: 35%;
        }
      }

      &__tag {
        display: none;
      }

      &__tags {
        border-radius: 0;
        border: 0;
        padding: 0 15px 0 0;
        min-height: 30px;
        background: none;
        z-index: 1;
      }

      &__single {
        padding: 1px 0 0;
        margin-top: 5px;
        background: none;
        white-space: nowrap;
        overflow: hidden;
        width: calc(100% - 25px);
        text-overflow: ellipsis;

        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
          padding: 5px 0 0;
        }
      }

      &__content-wrapper {
        min-height: 56px;
        border-radius: 0;
        box-shadow: 0 1px 5px rgba(0,0,0,.2), 0 2px 2px rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12);
        border: 0;
        margin-top: 2px;
        width: 100%;
        min-width: 100%;
        z-index: 100;
        overflow-x: hidden;
      }

      &__content {
        padding: 8px 0;
        z-index: 4;
      }

      &__element {
        & + li {
          margin-top: 0;
        }
      }

      &__option {
        font-size: 16px;
        font-weight: 400;
        color: #303030;
        min-height: 48px;
        display: flex;
        align-items: center;

        &:hover,
        &:active,
        &:focus,
        &--highlight {
          background: #dddddd;
        }

        &--selected,
        &--selected:hover,
        &--selected:focus,
        &--selected.multiselect__option--highlight {
          background: rgba(0, 0, 0, .12);
        }
        &--disabled,
        &--disabled:hover,
        &--disabled:focus,
        &--disabled.multiselect__option--highlight {
          background: transparent !important;
          color: #858585;
        }
      }
    }
  }
</style>
